// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =====================================================
   VARIABLES
===================================================== */

:root {
  --bg: #f0f4f8;
  --card: #ffffff;
  --primary: #2563eb;
  --primary-soft: #eff6ff;
  --primary-dark: #1d4ed8;
  --success: #16a34a;
  --success-soft: #f0fdf4;
  --danger: #dc2626;
  --danger-soft: #fef2f2;
  --warning: #d97706;
  --text: #111827;
  --text-soft: #6b7280;
  --text-muted: #9ca3af;
  --border: #e5e7eb;
  --border-soft: #f3f4f6;
  --shadow-sm: 0 1px 3px rgba(0,0,0,0.07), 0 1px 2px rgba(0,0,0,0.04);
  --shadow-md: 0 4px 14px rgba(0,0,0,0.08);
  --radius-sm: 8px;
  --radius-md: 12px;
  --radius-lg: 16px;
}

/* =====================================================
   GLOBAL
===================================================== */

*, *::before, *::after { box-sizing: border-box; }

body {
  margin: 0;
  background: var(--bg);
  font-family: Inter, system-ui, -apple-system, sans-serif;
  color: var(--text);
  font-size: 14px;
  line-height: 1.5;
}

.app {
  max-width: 1100px;
  margin: auto;
  padding: 16px;
  min-height: 100vh;
}

h2 { font-size: 18px; font-weight: 700; margin: 0 0 16px; color: var(--text); }
h3 { font-size: 15px; font-weight: 600; margin: 0 0 12px; color: var(--text); }

/* =====================================================
   HEADER
===================================================== */

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: var(--card);
  padding: 14px 20px;
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-sm);
  border: 1px solid var(--border);
  margin-bottom: 12px;
}

.month {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--text-muted);
  margin-bottom: 4px;
}

.header input[type="month"] {
  padding: 6px 10px;
  border-radius: var(--radius-sm);
  border: 1px solid var(--border);
  font-size: 14px;
  font-weight: 500;
  color: var(--text);
  background: var(--border-soft);
}

/* =====================================================
   BOUTON PRINCIPAL
===================================================== */

.cta {
  background: var(--primary);
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: var(--radius-sm);
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.15s, transform 0.1s;
}
.cta:hover { background: var(--primary-dark); }
.cta:active { transform: scale(0.98); }

/* =====================================================
   BOUTONS GÉNÉRIQUES
===================================================== */

.btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  border-radius: var(--radius-sm);
  border: 1px solid var(--border);
  font-family: inherit;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease;
  white-space: nowrap;
  background: white;
  color: var(--text);
}
.btn:hover { background: var(--border-soft); }
.btn:active { transform: scale(0.98); }

.btn-primary { background: var(--primary); color: white; border-color: var(--primary); }
.btn-primary:hover { background: var(--primary-dark); border-color: var(--primary-dark); }

.btn-ghost { background: none; border-color: transparent; color: var(--text-soft); }
.btn-ghost:hover { background: var(--border-soft); color: var(--text); }

.btn-danger { background: var(--danger); color: white; border-color: var(--danger); }
.btn-danger:hover { background: #b91c1c; border-color: #b91c1c; }

.btn:disabled { opacity: 0.45; cursor: default; pointer-events: none; }

/* =====================================================
   NAVIGATION (ONGLETS)
===================================================== */

.tabs {
  display: flex;
  gap: 4px;
  margin-bottom: 20px;
  background: var(--card);
  padding: 6px;
  border-radius: var(--radius-md);
  border: 1px solid var(--border);
  box-shadow: var(--shadow-sm);
}

.tabs button {
  background: none;
  border: none;
  padding: 8px 18px;
  border-radius: var(--radius-sm);
  color: var(--text-soft);
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  font-family: inherit;
  transition: all 0.15s;
}
.tabs button:hover { background: var(--border-soft); color: var(--text); }
.tabs button.active {
  background: var(--primary);
  color: white;
  font-weight: 600;
  box-shadow: 0 2px 6px rgba(37,99,235,0.25);
}

/* =====================================================
   PANNEAU AJOUT DÉPENSE
===================================================== */

.panel {
  background: var(--card);
  padding: 24px;
  border-radius: var(--radius-lg);
  margin-bottom: 20px;
  border: 1px solid var(--border);
  box-shadow: var(--shadow-md);
}

.panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.panel-header h2 { margin: 0; font-size: 18px; }
.panel-header button {
  background: var(--border-soft);
  border: none;
  width: 32px; height: 32px;
  border-radius: 50%;
  font-size: 16px;
  cursor: pointer;
  color: var(--text-soft);
  display: flex; align-items: center; justify-content: center;
  transition: background 0.15s;
}
.panel-header button:hover { background: var(--border); }

/* =====================================================
   SECTION CARD
===================================================== */

.section-card {
  background: var(--card);
  border-radius: var(--radius-lg);
  border: 1px solid var(--border);
  box-shadow: var(--shadow-sm);
  padding: 24px;
  margin-bottom: 20px;
}

/* =====================================================
   KPI GRID (Dashboard)
===================================================== */

.kpi-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 14px;
  margin-bottom: 20px;
}

.kpi-card {
  background: var(--card);
  border-radius: var(--radius-md);
  border: 1px solid var(--border);
  box-shadow: var(--shadow-sm);
  padding: 20px 22px;
}

.kpi-label {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--text-muted);
  margin-bottom: 8px;
}

.kpi-value {
  font-size: 26px;
  font-weight: 700;
  color: var(--text);
  letter-spacing: -0.5px;
}

.kpi-value.kpi-success { color: var(--success); }
.kpi-value.kpi-danger  { color: var(--danger); }
.kpi-value.kpi-primary { color: var(--primary); }

/* =====================================================
   CONTRIBUTION CARDS (Dashboard)
===================================================== */

.contribution-section {
  background: var(--card);
  border-radius: var(--radius-lg);
  border: 1px solid var(--border);
  box-shadow: var(--shadow-sm);
  padding: 22px 24px;
  margin-bottom: 20px;
}

.contribution-grid {
  display: flex;
  gap: 14px;
  flex-wrap: wrap;
  margin-top: 14px;
}

.contribution-card {
  flex: 1 1;
  min-width: 150px;
  background: var(--primary-soft);
  border-radius: var(--radius-md);
  border: 1px solid #dbeafe;
  padding: 16px 20px;
}

.contribution-name {
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--primary);
  margin-bottom: 6px;
}

.contribution-amount {
  font-size: 22px;
  font-weight: 700;
  color: var(--primary-dark);
  letter-spacing: -0.5px;
}

.contribution-ratio {
  font-size: 12px;
  color: var(--text-soft);
  margin-top: 4px;
}

/* =====================================================
   TABLE WRAPPER
===================================================== */

.table-wrapper {
  border-radius: var(--radius-md);
  overflow-x: auto;   /* scroll horizontal sur mobile */
  overflow-y: visible;
  border: 1px solid var(--border);
  box-shadow: var(--shadow-sm);
  margin-bottom: 20px;
  -webkit-overflow-scrolling: touch;
}

/* =====================================================
   TABLES
===================================================== */

table {
  width: 100%;
  border-collapse: collapse;
  background: var(--card);
}

thead th {
  background: #f9fafb;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--text-soft);
  padding: 12px 14px;
  border-bottom: 1px solid var(--border);
  text-align: left;
  white-space: nowrap;
}

tbody td {
  padding: 11px 14px;
  border-bottom: 1px solid var(--border-soft);
  font-size: 13px;
  color: var(--text);
}

tbody tr:last-child td { border-bottom: none; }
tbody tr:hover { background: #fafbfc; }

/* =====================================================
   INPUTS & SELECTS
===================================================== */

input[type="text"],
input[type="number"],
input[type="date"],
input[type="month"],
select,
textarea {
  padding: 8px 11px;
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  font-family: inherit;
  font-size: 13px;
  color: var(--text);
  background: white;
  transition: border-color 0.15s, box-shadow 0.15s;
}

input:focus, select:focus, textarea:focus {
  outline: none;
  border-color: var(--primary);
  box-shadow: 0 0 0 3px rgba(37,99,235,0.1);
}

/* =====================================================
   FILTER BAR (Transactions)
===================================================== */

.filter-bar {
  background: var(--card);
  border-radius: var(--radius-md);
  border: 1px solid var(--border);
  box-shadow: var(--shadow-sm);
  padding: 14px 16px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  margin-bottom: 16px;
}

.filter-bar input,
.filter-bar select {
  background: var(--border-soft);
  border-color: transparent;
}
.filter-bar input:focus,
.filter-bar select:focus {
  background: white;
  border-color: var(--primary);
}

/* =====================================================
   FORM GRID
===================================================== */

.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}
.form-group { display: flex; flex-direction: column; gap: 5px; }
.form-group label { font-size: 12px; font-weight: 600; color: var(--text-soft); text-transform: uppercase; letter-spacing: 0.04em; }
.form-group input,
.form-group select { width: 100%; }
.form-full { grid-column: span 2; }

/* =====================================================
   BADGE / TAG
===================================================== */

.badge {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 99px;
  font-size: 11px;
  font-weight: 600;
}
.badge-expense { background: #fee2e2; color: var(--danger); }
.badge-income  { background: #dcfce7; color: var(--success); }

/* =====================================================
   GLOBAL BUTTON RESET (kept minimal)
===================================================== */

button { font-family: inherit; cursor: pointer; }

/* =====================================================
   CHARTS ROW (empile verticalement sur mobile)
===================================================== */

.charts-row {
  display: flex;
  gap: 24px;
  align-items: flex-start;
  margin-bottom: 32px;
}
.charts-row > div:first-child { flex: 0 0 44%; min-width: 300px; }
.charts-row > div:last-child  { flex: 1 1; }

/* =====================================================
   SUBNAV (onglets Budget / Paramètres)
===================================================== */

.subnav {
  display: flex;
  gap: 8px;
  margin-bottom: 20px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 2px;
}
.subnav button {
  flex-shrink: 0;
  padding: 7px 16px;
  border-radius: 8px;
  border: 1px solid #ddd;
  font-size: 14px;
  cursor: pointer;
  white-space: nowrap;
  font-family: inherit;
}

/* =====================================================
   MOBILE  ≤ 640 px
===================================================== */

@media (max-width: 640px) {

  .app { padding: 10px; }

  /* Header */
  .header { flex-direction: column; align-items: stretch; gap: 10px; padding: 12px 14px; }
  .header > div:first-child { display: flex; align-items: center; justify-content: center; gap: 8px; }
  .header > div:last-child  { display: flex; gap: 8px; }
  .cta { flex: 1 1; padding: 12px; text-align: center; font-size: 14px; }
  .header > div:last-child button:last-child { padding: 10px 12px; font-size: 13px; }

  /* Onglets principaux */
  .tabs { overflow-x: auto; -webkit-overflow-scrolling: touch; padding: 4px; gap: 2px; }
  .tabs button { white-space: nowrap; flex-shrink: 0; padding: 8px 14px; font-size: 13px; }

  /* KPI + forms */
  .kpi-grid { grid-template-columns: repeat(2, 1fr); gap: 8px; }
  .kpi-value { font-size: 20px; }
  .kpi-card { padding: 14px 16px; }
  .form-grid { grid-template-columns: 1fr; }
  .form-full { grid-column: span 1; }

  /* Graphiques : empile verticalement */
  .charts-row {
    flex-direction: column;
    gap: 16px;
  }
  .charts-row > div:first-child { flex: none; min-width: 0; width: 100%; }
  .charts-row > div:last-child  { width: 100%; }

  /* Tables : cible tactile + taille texte */
  tbody td { padding: 10px 10px; font-size: 12px; }
  thead th { padding: 10px 10px; font-size: 10px; }

  /* Filtre transactions */
  .filter-bar { gap: 6px; }
  .filter-bar input, .filter-bar select { font-size: 13px; }

  /* Modals plein écran */
  [style*="position: fixed"][style*="zIndex: 1000"] > div,
  [style*="position:fixed"][style*="z-index:1000"] > div {
    width: 100% !important;
    max-width: 100% !important;
    border-radius: var(--radius-lg) var(--radius-lg) 0 0 !important;
    position: fixed !important;
    bottom: 0 !important;
    left: 0 !important;
    max-height: 90vh !important;
    overflow-y: auto !important;
  }

  /* Section card */
  .section-card { padding: 16px; }
  .panel { padding: 16px; }
}

/* =====================================================
   MOBILE  ≤ 400 px (petits écrans)
===================================================== */

@media (max-width: 400px) {
  .kpi-grid { grid-template-columns: 1fr; }
  .tabs button { padding: 7px 10px; font-size: 12px; }
}
`, "",{"version":3,"sources":["webpack://./src/NewUI.css"],"names":[],"mappings":"AAAA;;uDAEuD;;AAEvD;EACE,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;EACtB,mEAAmE;EACnE,wCAAwC;EACxC,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;;uDAEuD;;AAEvD,yBAAyB,sBAAsB,EAAE;;AAEjD;EACE,SAAS;EACT,qBAAqB;EACrB,wDAAwD;EACxD,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,iBAAiB;AACnB;;AAEA,KAAK,eAAe,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;AAC9E,KAAK,eAAe,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;;AAE9E;;uDAEuD;;AAEvD;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,+BAA+B;EAC/B,4BAA4B;EAC5B,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;;uDAEuD;;AAEvD;EACE,0BAA0B;EAC1B,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,4CAA4C;AAC9C;AACA,aAAa,+BAA+B,EAAE;AAC9C,cAAc,sBAAsB,EAAE;;AAEtC;;uDAEuD;;AAEvD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,+BAA+B;EAC/B,+BAA+B;EAC/B,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;AACA,aAAa,8BAA8B,EAAE;AAC7C,cAAc,sBAAsB,EAAE;;AAEtC,eAAe,0BAA0B,EAAE,YAAY,EAAE,4BAA4B,EAAE;AACvF,qBAAqB,+BAA+B,EAAE,iCAAiC,EAAE;;AAEzF,aAAa,gBAAgB,EAAE,yBAAyB,EAAE,uBAAuB,EAAE;AACnF,mBAAmB,8BAA8B,EAAE,kBAAkB,EAAE;;AAEvE,cAAc,yBAAyB,EAAE,YAAY,EAAE,2BAA2B,EAAE;AACpF,oBAAoB,mBAAmB,EAAE,qBAAqB,EAAE;;AAEhE,gBAAgB,aAAa,EAAE,eAAe,EAAE,oBAAoB,EAAE;;AAEtE;;uDAEuD;;AAEvD;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,+BAA+B;EAC/B,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;EAC/B,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;AACvB;AACA,qBAAqB,8BAA8B,EAAE,kBAAkB,EAAE;AACzE;EACE,0BAA0B;EAC1B,YAAY;EACZ,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;;uDAEuD;;AAEvD;EACE,uBAAuB;EACvB,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;AACA,mBAAmB,SAAS,EAAE,eAAe,EAAE;AAC/C;EACE,8BAA8B;EAC9B,YAAY;EACZ,WAAW,EAAE,YAAY;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,uBAAuB;EACvB,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,4BAA4B;AAC9B;AACA,6BAA6B,yBAAyB,EAAE;;AAExD;;uDAEuD;;AAEvD;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,+BAA+B;EAC/B,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;AACrB;;AAEA;;uDAEuD;;AAEvD;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,+BAA+B;EAC/B,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,yBAAyB,qBAAqB,EAAE;AAChD,yBAAyB,oBAAoB,EAAE;AAC/C,yBAAyB,qBAAqB,EAAE;;AAEhD;;uDAEuD;;AAEvD;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,+BAA+B;EAC/B,4BAA4B;EAC5B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,+BAA+B;EAC/B,+BAA+B;EAC/B,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,eAAe;AACjB;;AAEA;;uDAEuD;;AAEvD;EACE,+BAA+B;EAC/B,gBAAgB,IAAI,iCAAiC;EACrD,mBAAmB;EACnB,+BAA+B;EAC/B,4BAA4B;EAC5B,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;;uDAEuD;;AAEvD;EACE,WAAW;EACX,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,sCAAsC;EACtC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,2CAA2C;EAC3C,eAAe;EACf,kBAAkB;AACpB;;AAEA,yBAAyB,mBAAmB,EAAE;AAC9C,iBAAiB,mBAAmB,EAAE;;AAEtC;;uDAEuD;;AAEvD;;;;;;EAME,iBAAiB;EACjB,+BAA+B;EAC/B,+BAA+B;EAC/B,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,yCAAyC;AAC3C;;AAEA;;uDAEuD;;AAEvD;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,+BAA+B;EAC/B,4BAA4B;EAC5B,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,8BAA8B;EAC9B,yBAAyB;AAC3B;AACA;;EAEE,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;;uDAEuD;;AAEvD;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;AACA,cAAc,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AAC/D,oBAAoB,eAAe,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,yBAAyB,EAAE,sBAAsB,EAAE;AACnI;qBACqB,WAAW,EAAE;AAClC,aAAa,mBAAmB,EAAE;;AAElC;;uDAEuD;;AAEvD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;AACA,iBAAiB,mBAAmB,EAAE,oBAAoB,EAAE;AAC5D,iBAAiB,mBAAmB,EAAE,qBAAqB,EAAE;;AAE7D;;uDAEuD;;AAEvD,SAAS,oBAAoB,EAAE,eAAe,EAAE;;AAEhD;;uDAEuD;;AAEvD;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,mBAAmB;AACrB;AACA,gCAAgC,aAAa,EAAE,gBAAgB,EAAE;AACjE,gCAAgC,SAAO,EAAE;;AAEzC;;uDAEuD;;AAEvD;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;EAChB,iCAAiC;EACjC,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;;uDAEuD;;AAEvD;;EAEE,OAAO,aAAa,EAAE;;EAEtB,WAAW;EACX,UAAU,sBAAsB,EAAE,oBAAoB,EAAE,SAAS,EAAE,kBAAkB,EAAE;EACvF,4BAA4B,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,QAAQ,EAAE;EACnG,4BAA4B,aAAa,EAAE,QAAQ,EAAE;EACrD,OAAO,SAAO,EAAE,aAAa,EAAE,kBAAkB,EAAE,eAAe,EAAE;EACpE,6CAA6C,kBAAkB,EAAE,eAAe,EAAE;;EAElF,uBAAuB;EACvB,QAAQ,gBAAgB,EAAE,iCAAiC,EAAE,YAAY,EAAE,QAAQ,EAAE;EACrF,eAAe,mBAAmB,EAAE,cAAc,EAAE,iBAAiB,EAAE,eAAe,EAAE;;EAExF,gBAAgB;EAChB,YAAY,qCAAqC,EAAE,QAAQ,EAAE;EAC7D,aAAa,eAAe,EAAE;EAC9B,YAAY,kBAAkB,EAAE;EAChC,aAAa,0BAA0B,EAAE;EACzC,aAAa,mBAAmB,EAAE;;EAElC,sCAAsC;EACtC;IACE,sBAAsB;IACtB,SAAS;EACX;EACA,gCAAgC,UAAU,EAAE,YAAY,EAAE,WAAW,EAAE;EACvE,gCAAgC,WAAW,EAAE;;EAE7C,0CAA0C;EAC1C,WAAW,kBAAkB,EAAE,eAAe,EAAE;EAChD,WAAW,kBAAkB,EAAE,eAAe,EAAE;;EAEhD,wBAAwB;EACxB,cAAc,QAAQ,EAAE;EACxB,wCAAwC,eAAe,EAAE;;EAEzD,uBAAuB;EACvB;;IAEE,sBAAsB;IACtB,0BAA0B;IAC1B,+DAA+D;IAC/D,0BAA0B;IAC1B,oBAAoB;IACpB,kBAAkB;IAClB,2BAA2B;IAC3B,2BAA2B;EAC7B;;EAEA,iBAAiB;EACjB,gBAAgB,aAAa,EAAE;EAC/B,SAAS,aAAa,EAAE;AAC1B;;AAEA;;uDAEuD;;AAEvD;EACE,YAAY,0BAA0B,EAAE;EACxC,eAAe,iBAAiB,EAAE,eAAe,EAAE;AACrD","sourcesContent":["/* =====================================================\n   VARIABLES\n===================================================== */\n\n:root {\n  --bg: #f0f4f8;\n  --card: #ffffff;\n  --primary: #2563eb;\n  --primary-soft: #eff6ff;\n  --primary-dark: #1d4ed8;\n  --success: #16a34a;\n  --success-soft: #f0fdf4;\n  --danger: #dc2626;\n  --danger-soft: #fef2f2;\n  --warning: #d97706;\n  --text: #111827;\n  --text-soft: #6b7280;\n  --text-muted: #9ca3af;\n  --border: #e5e7eb;\n  --border-soft: #f3f4f6;\n  --shadow-sm: 0 1px 3px rgba(0,0,0,0.07), 0 1px 2px rgba(0,0,0,0.04);\n  --shadow-md: 0 4px 14px rgba(0,0,0,0.08);\n  --radius-sm: 8px;\n  --radius-md: 12px;\n  --radius-lg: 16px;\n}\n\n/* =====================================================\n   GLOBAL\n===================================================== */\n\n*, *::before, *::after { box-sizing: border-box; }\n\nbody {\n  margin: 0;\n  background: var(--bg);\n  font-family: Inter, system-ui, -apple-system, sans-serif;\n  color: var(--text);\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n.app {\n  max-width: 1100px;\n  margin: auto;\n  padding: 16px;\n  min-height: 100vh;\n}\n\nh2 { font-size: 18px; font-weight: 700; margin: 0 0 16px; color: var(--text); }\nh3 { font-size: 15px; font-weight: 600; margin: 0 0 12px; color: var(--text); }\n\n/* =====================================================\n   HEADER\n===================================================== */\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: var(--card);\n  padding: 14px 20px;\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-sm);\n  border: 1px solid var(--border);\n  margin-bottom: 12px;\n}\n\n.month {\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: var(--text-muted);\n  margin-bottom: 4px;\n}\n\n.header input[type=\"month\"] {\n  padding: 6px 10px;\n  border-radius: var(--radius-sm);\n  border: 1px solid var(--border);\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--text);\n  background: var(--border-soft);\n}\n\n/* =====================================================\n   BOUTON PRINCIPAL\n===================================================== */\n\n.cta {\n  background: var(--primary);\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: var(--radius-sm);\n  font-weight: 600;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background 0.15s, transform 0.1s;\n}\n.cta:hover { background: var(--primary-dark); }\n.cta:active { transform: scale(0.98); }\n\n/* =====================================================\n   BOUTONS GÉNÉRIQUES\n===================================================== */\n\n.btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 14px;\n  border-radius: var(--radius-sm);\n  border: 1px solid var(--border);\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  white-space: nowrap;\n  background: white;\n  color: var(--text);\n}\n.btn:hover { background: var(--border-soft); }\n.btn:active { transform: scale(0.98); }\n\n.btn-primary { background: var(--primary); color: white; border-color: var(--primary); }\n.btn-primary:hover { background: var(--primary-dark); border-color: var(--primary-dark); }\n\n.btn-ghost { background: none; border-color: transparent; color: var(--text-soft); }\n.btn-ghost:hover { background: var(--border-soft); color: var(--text); }\n\n.btn-danger { background: var(--danger); color: white; border-color: var(--danger); }\n.btn-danger:hover { background: #b91c1c; border-color: #b91c1c; }\n\n.btn:disabled { opacity: 0.45; cursor: default; pointer-events: none; }\n\n/* =====================================================\n   NAVIGATION (ONGLETS)\n===================================================== */\n\n.tabs {\n  display: flex;\n  gap: 4px;\n  margin-bottom: 20px;\n  background: var(--card);\n  padding: 6px;\n  border-radius: var(--radius-md);\n  border: 1px solid var(--border);\n  box-shadow: var(--shadow-sm);\n}\n\n.tabs button {\n  background: none;\n  border: none;\n  padding: 8px 18px;\n  border-radius: var(--radius-sm);\n  color: var(--text-soft);\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  font-family: inherit;\n  transition: all 0.15s;\n}\n.tabs button:hover { background: var(--border-soft); color: var(--text); }\n.tabs button.active {\n  background: var(--primary);\n  color: white;\n  font-weight: 600;\n  box-shadow: 0 2px 6px rgba(37,99,235,0.25);\n}\n\n/* =====================================================\n   PANNEAU AJOUT DÉPENSE\n===================================================== */\n\n.panel {\n  background: var(--card);\n  padding: 24px;\n  border-radius: var(--radius-lg);\n  margin-bottom: 20px;\n  border: 1px solid var(--border);\n  box-shadow: var(--shadow-md);\n}\n\n.panel-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n.panel-header h2 { margin: 0; font-size: 18px; }\n.panel-header button {\n  background: var(--border-soft);\n  border: none;\n  width: 32px; height: 32px;\n  border-radius: 50%;\n  font-size: 16px;\n  cursor: pointer;\n  color: var(--text-soft);\n  display: flex; align-items: center; justify-content: center;\n  transition: background 0.15s;\n}\n.panel-header button:hover { background: var(--border); }\n\n/* =====================================================\n   SECTION CARD\n===================================================== */\n\n.section-card {\n  background: var(--card);\n  border-radius: var(--radius-lg);\n  border: 1px solid var(--border);\n  box-shadow: var(--shadow-sm);\n  padding: 24px;\n  margin-bottom: 20px;\n}\n\n/* =====================================================\n   KPI GRID (Dashboard)\n===================================================== */\n\n.kpi-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 14px;\n  margin-bottom: 20px;\n}\n\n.kpi-card {\n  background: var(--card);\n  border-radius: var(--radius-md);\n  border: 1px solid var(--border);\n  box-shadow: var(--shadow-sm);\n  padding: 20px 22px;\n}\n\n.kpi-label {\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: var(--text-muted);\n  margin-bottom: 8px;\n}\n\n.kpi-value {\n  font-size: 26px;\n  font-weight: 700;\n  color: var(--text);\n  letter-spacing: -0.5px;\n}\n\n.kpi-value.kpi-success { color: var(--success); }\n.kpi-value.kpi-danger  { color: var(--danger); }\n.kpi-value.kpi-primary { color: var(--primary); }\n\n/* =====================================================\n   CONTRIBUTION CARDS (Dashboard)\n===================================================== */\n\n.contribution-section {\n  background: var(--card);\n  border-radius: var(--radius-lg);\n  border: 1px solid var(--border);\n  box-shadow: var(--shadow-sm);\n  padding: 22px 24px;\n  margin-bottom: 20px;\n}\n\n.contribution-grid {\n  display: flex;\n  gap: 14px;\n  flex-wrap: wrap;\n  margin-top: 14px;\n}\n\n.contribution-card {\n  flex: 1;\n  min-width: 150px;\n  background: var(--primary-soft);\n  border-radius: var(--radius-md);\n  border: 1px solid #dbeafe;\n  padding: 16px 20px;\n}\n\n.contribution-name {\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: var(--primary);\n  margin-bottom: 6px;\n}\n\n.contribution-amount {\n  font-size: 22px;\n  font-weight: 700;\n  color: var(--primary-dark);\n  letter-spacing: -0.5px;\n}\n\n.contribution-ratio {\n  font-size: 12px;\n  color: var(--text-soft);\n  margin-top: 4px;\n}\n\n/* =====================================================\n   TABLE WRAPPER\n===================================================== */\n\n.table-wrapper {\n  border-radius: var(--radius-md);\n  overflow-x: auto;   /* scroll horizontal sur mobile */\n  overflow-y: visible;\n  border: 1px solid var(--border);\n  box-shadow: var(--shadow-sm);\n  margin-bottom: 20px;\n  -webkit-overflow-scrolling: touch;\n}\n\n/* =====================================================\n   TABLES\n===================================================== */\n\ntable {\n  width: 100%;\n  border-collapse: collapse;\n  background: var(--card);\n}\n\nthead th {\n  background: #f9fafb;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: var(--text-soft);\n  padding: 12px 14px;\n  border-bottom: 1px solid var(--border);\n  text-align: left;\n  white-space: nowrap;\n}\n\ntbody td {\n  padding: 11px 14px;\n  border-bottom: 1px solid var(--border-soft);\n  font-size: 13px;\n  color: var(--text);\n}\n\ntbody tr:last-child td { border-bottom: none; }\ntbody tr:hover { background: #fafbfc; }\n\n/* =====================================================\n   INPUTS & SELECTS\n===================================================== */\n\ninput[type=\"text\"],\ninput[type=\"number\"],\ninput[type=\"date\"],\ninput[type=\"month\"],\nselect,\ntextarea {\n  padding: 8px 11px;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  font-family: inherit;\n  font-size: 13px;\n  color: var(--text);\n  background: white;\n  transition: border-color 0.15s, box-shadow 0.15s;\n}\n\ninput:focus, select:focus, textarea:focus {\n  outline: none;\n  border-color: var(--primary);\n  box-shadow: 0 0 0 3px rgba(37,99,235,0.1);\n}\n\n/* =====================================================\n   FILTER BAR (Transactions)\n===================================================== */\n\n.filter-bar {\n  background: var(--card);\n  border-radius: var(--radius-md);\n  border: 1px solid var(--border);\n  box-shadow: var(--shadow-sm);\n  padding: 14px 16px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  align-items: center;\n  margin-bottom: 16px;\n}\n\n.filter-bar input,\n.filter-bar select {\n  background: var(--border-soft);\n  border-color: transparent;\n}\n.filter-bar input:focus,\n.filter-bar select:focus {\n  background: white;\n  border-color: var(--primary);\n}\n\n/* =====================================================\n   FORM GRID\n===================================================== */\n\n.form-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n}\n.form-group { display: flex; flex-direction: column; gap: 5px; }\n.form-group label { font-size: 12px; font-weight: 600; color: var(--text-soft); text-transform: uppercase; letter-spacing: 0.04em; }\n.form-group input,\n.form-group select { width: 100%; }\n.form-full { grid-column: span 2; }\n\n/* =====================================================\n   BADGE / TAG\n===================================================== */\n\n.badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 8px;\n  border-radius: 99px;\n  font-size: 11px;\n  font-weight: 600;\n}\n.badge-expense { background: #fee2e2; color: var(--danger); }\n.badge-income  { background: #dcfce7; color: var(--success); }\n\n/* =====================================================\n   GLOBAL BUTTON RESET (kept minimal)\n===================================================== */\n\nbutton { font-family: inherit; cursor: pointer; }\n\n/* =====================================================\n   CHARTS ROW (empile verticalement sur mobile)\n===================================================== */\n\n.charts-row {\n  display: flex;\n  gap: 24px;\n  align-items: flex-start;\n  margin-bottom: 32px;\n}\n.charts-row > div:first-child { flex: 0 0 44%; min-width: 300px; }\n.charts-row > div:last-child  { flex: 1; }\n\n/* =====================================================\n   SUBNAV (onglets Budget / Paramètres)\n===================================================== */\n\n.subnav {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 20px;\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n  padding-bottom: 2px;\n}\n.subnav button {\n  flex-shrink: 0;\n  padding: 7px 16px;\n  border-radius: 8px;\n  border: 1px solid #ddd;\n  font-size: 14px;\n  cursor: pointer;\n  white-space: nowrap;\n  font-family: inherit;\n}\n\n/* =====================================================\n   MOBILE  ≤ 640 px\n===================================================== */\n\n@media (max-width: 640px) {\n\n  .app { padding: 10px; }\n\n  /* Header */\n  .header { flex-direction: column; align-items: stretch; gap: 10px; padding: 12px 14px; }\n  .header > div:first-child { display: flex; align-items: center; justify-content: center; gap: 8px; }\n  .header > div:last-child  { display: flex; gap: 8px; }\n  .cta { flex: 1; padding: 12px; text-align: center; font-size: 14px; }\n  .header > div:last-child button:last-child { padding: 10px 12px; font-size: 13px; }\n\n  /* Onglets principaux */\n  .tabs { overflow-x: auto; -webkit-overflow-scrolling: touch; padding: 4px; gap: 2px; }\n  .tabs button { white-space: nowrap; flex-shrink: 0; padding: 8px 14px; font-size: 13px; }\n\n  /* KPI + forms */\n  .kpi-grid { grid-template-columns: repeat(2, 1fr); gap: 8px; }\n  .kpi-value { font-size: 20px; }\n  .kpi-card { padding: 14px 16px; }\n  .form-grid { grid-template-columns: 1fr; }\n  .form-full { grid-column: span 1; }\n\n  /* Graphiques : empile verticalement */\n  .charts-row {\n    flex-direction: column;\n    gap: 16px;\n  }\n  .charts-row > div:first-child { flex: none; min-width: 0; width: 100%; }\n  .charts-row > div:last-child  { width: 100%; }\n\n  /* Tables : cible tactile + taille texte */\n  tbody td { padding: 10px 10px; font-size: 12px; }\n  thead th { padding: 10px 10px; font-size: 10px; }\n\n  /* Filtre transactions */\n  .filter-bar { gap: 6px; }\n  .filter-bar input, .filter-bar select { font-size: 13px; }\n\n  /* Modals plein écran */\n  [style*=\"position: fixed\"][style*=\"zIndex: 1000\"] > div,\n  [style*=\"position:fixed\"][style*=\"z-index:1000\"] > div {\n    width: 100% !important;\n    max-width: 100% !important;\n    border-radius: var(--radius-lg) var(--radius-lg) 0 0 !important;\n    position: fixed !important;\n    bottom: 0 !important;\n    left: 0 !important;\n    max-height: 90vh !important;\n    overflow-y: auto !important;\n  }\n\n  /* Section card */\n  .section-card { padding: 16px; }\n  .panel { padding: 16px; }\n}\n\n/* =====================================================\n   MOBILE  ≤ 400 px (petits écrans)\n===================================================== */\n\n@media (max-width: 400px) {\n  .kpi-grid { grid-template-columns: 1fr; }\n  .tabs button { padding: 7px 10px; font-size: 12px; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
